import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import loading from './modules/loading'
import notifications from './modules/notification'
import utils from './modules/utils'
import templates from "./modules/templates";
import requests from "./modules/requests";
import form from './modules/form'
import createPersistedState from  'vuex-persistedstate'

Vue.use(Vuex);


export default new Vuex.Store({
	modules: {
		user,
		loading,
		notifications,
		utils,
        templates,
        requests,
        form
	},
    plugins:[
        createPersistedState({
            key: ['utils','requests'],
            paths: ['utils','requests']
        }),
    ],
})
